import React from 'react'
import { motion } from 'framer-motion'
import { Guitar, Drum, Music } from 'lucide-react'

const AboutLittleEddie = () => (
  <div className="pt-16 lg:pt-20 min-h-screen">
    <section className="section-padding py-20">
      <div className="container-max max-w-5xl mx-auto">
        <motion.div className="text-center mb-12" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <h1 className="text-5xl font-display font-bold text-white mb-4">Little Eddie Audio</h1>
          <p className="text-xl text-white/70">Performance • Production • Real Music</p>
        </motion.div>

        <div className="glass-card p-8 mb-8">
          <h2 className="text-2xl font-display font-semibold text-white mb-3">Edwin Perry</h2>
          <p className="text-white/80">
            Edwin is a classically trained guitarist and drummer from Wichita, performing everything from classic guitar and jazz to rock and techno—always with real musicianship and deep stage craft. Little Eddie Audio supports Wichita’s stages with production, audio, and editorial—sharing performance reviews, gear insights, and community know‑how.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {[{icon: Guitar, title: 'Guitar & Jazz'}, {icon: Drum, title: 'Rock & Rhythm'}, {icon: Music, title: 'Techno Riffs'}].map((f, i) => {
            const Icon = f.icon as any
            return (
              <motion.div key={f.title} className="glass-card p-8 text-center" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.1 }} viewport={{ once: true }}>
                <Icon size={36} className="text-le-accent mx-auto mb-4" />
                <h3 className="text-white font-semibold">{f.title}</h3>
              </motion.div>
            )
          })}
        </div>
      </div>
    </section>
  </div>
)

export default AboutLittleEddie

